
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import OverviewContent from './OverviewContent';
import DetailsContent from './DetailsContent';
import ServicesContent from './ServicesContent';
import RightsContent from './RightsContent';

const DatenschutzContainer = () => {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="bg-white rounded-2xl shadow-soft p-8 animate-fade-in">
        <h2 className="text-3xl font-bold text-joerg-800 mb-6">Datenschutzerklärung</h2>
        
        <Tabs defaultValue="overview" className="mt-6">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-4">
            <TabsTrigger value="overview">Überblick</TabsTrigger>
            <TabsTrigger value="details">Grundlagen</TabsTrigger>
            <TabsTrigger value="services">Dienste</TabsTrigger>
            <TabsTrigger value="rights">Ihre Rechte</TabsTrigger>
          </TabsList>
          
          <TabsContent value="overview" className="pt-6">
            <OverviewContent />
          </TabsContent>
          
          <TabsContent value="details" className="pt-6">
            <DetailsContent />
          </TabsContent>
          
          <TabsContent value="services" className="pt-6">
            <ServicesContent />
          </TabsContent>
          
          <TabsContent value="rights" className="pt-6">
            <RightsContent />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default DatenschutzContainer;
